export class FormValidationRuleService {
  requiredCheckbox() {
    return {
      getMessage: (field) => "Le champs " + field + " est obligatoire.",
      validate: (value) => !!value,
    };
  }
}
export const Instance = new FormValidationRuleService();